import React, { useEffect, useState } from 'react';
import './styles.css';
import { useDataProvider } from 'react-admin';

const ImageUploaderButton = (props) => {
  const { onAdd } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [files, setFiles] = useState<any>([]);
  const [url, setUrl] = useState<string>('');
  const dataProvider = useDataProvider();

  function onChange(event) {
    let files = event.target.files;
    onAdd(files);
    event.target.value = null;
  }
  return (
    <div className='image-uploader-field'>
      {url ? (
        <div>
          <img src={url} alt={url} />
        </div>
      ) : (
        <div>
          <input
            type='file'
            id='image-file'
            accept='image/x-png, image/jpeg'
            style={{ display: 'none' }}
            onChange={onChange}
            multiple
          />
          <label id='image-label' htmlFor='image-file'>
            Select Image(s)
          </label>
        </div>
      )}
    </div>
  );
};

export default ImageUploaderButton;
